import React from 'react';

const About = () => {
  return (
    <div>
      <h1>Tennisgemeinschaft Thedinghausen</h1>
      <p>
        Willkommen zur Vereinsmeisterschaft der Tennisgemeinschaft Thedinghausen! 
        Hier finden Sie alle Informationen zu unserem Turnier, das sowohl eine Gruppenphase 
        als auch eine Knockout-Phase umfasst.
      </p>
      <p>
        Die Vereinsmeisterschaft bietet Spielern die Möglichkeit, ihre Fähigkeiten 
        zu messen und sich in spannenden Matches zu beweisen. Jeder Spieler kann 
        seine Begegnungen selbst planen und den gewünschten Tag sowie den Platz 
        für das Spiel auswählen.
      </p>
      <p>
        Wir wünschen allen Teilnehmern viel Erfolg und Spaß!
      </p>
      <p>
        Vereinskleidung und Fanartikel gibt es in unserem{" "}
        <a href="https://tennis-thedinghausen.fan12.de/" target="_blank" rel="noreferrer">Fanshop</a>.
      </p>
    </div>
  );
};

export default About;